var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptopIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "60px",
    viewBox: "0 0 92 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_Laptop_1113458") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Laptop_1113458",
    fill: "#90A9C0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2,51.9 L86.6,51.9 L86.6,5.4 C86.6,2.7 84.4,0.5 81.7,0.5 L10.2,0.5 C7.5,0.5 5.3,2.7 5.3,5.4 L5.3,51.9 L3.8,51.9 C1.7,51.9 0,53.6 0,55.7 C0,57.8 1.7,59.5 3.8,59.5 L88.2,59.5 C90.3,59.5 92,57.8 92,55.7 C92,53.6 90.3,51.9 88.2,51.9 Z M52.1,55 L39.9,55 C39.6,55 39.3,54.7 39.3,54.4 C39.3,54.1 39.5,53.9 39.8,53.8 L52.3,53.8 C52.6,53.9 52.8,54.1 52.8,54.4 C52.7,54.7 52.4,55 52.1,55 Z M81.7,51.9 L52.4,51.9 C52.3,51.9 52.2,51.9 52.1,51.9 L39.9,51.9 C39.8,51.9 39.7,51.9 39.6,51.9 L10.3,51.9 L10.3,5.8 L81.7,5.8 L81.7,51.9 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopIcon);
export default __webpack_public_path__ + "static/media/laptop_icon.2dd1c95d9b5e8b1f5a13ca620331e8d3.svg";
export { ForwardRef as ReactComponent };